import React from 'react'
import {Redirect} from 'react-router-dom'
import {Query} from 'react-apollo'
import {get} from 'lodash'

import {USER} from '../graphql/query'

export default (Component, isRequireEmailVerified = true) => props => {
  return (
    <Query query={USER}>
      {({loading, error, data}) => {
        if (
          !loading &&
          get(data, 'me.isEmailVerified') !== isRequireEmailVerified
        ) return <Redirect to="/login" />

        return <Component {...props} />
      }}
    </Query>
  )
}



// WEBPACK FOOTER //
// ./src/auth/requireAuth.js